export default __webpack_public_path__ + "static/media/header2.00a3220f.jpg";